import _extends from "@babel/runtime/helpers/extends";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTypography } from '../typography/typography';
export var EmbersModalContentText = function EmbersModalContentText(props) {
  return /*#__PURE__*/React.createElement(EmbersTypography, _extends({
    variant: "body"
  }, props));
};